module.exports = __webpack_public_path__ + "media/Mobile.b65007e6.mp4";